<div [class]="theme ? theme : 'one-portal'">
  <form [formGroup]="formulaForm" class="collection-price">
    <p>Set Kit Retail Price Formula</p>
    <h1></h1>

    <div class="">
      <p>Change the Retail Price for all the frames in this kit</p>
      <div class="collection-price-formula">
        <div class="form-retail">
          <mat-form-field>
            <mat-select matInput placeholder="Wholesale Price" formControlName="priceType" required>
              <mat-option role="menuitem" *ngFor="let item of priceSelections" [value]="item">
                {{ item.priceName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="collection-price-div">
          <div class="form-sign"><span>x</span></div>
          <div class="form-symbol">
            <mat-form-field>
              <input
                matInput
                class="form-symbol__input"
                [ngClass]="{ 'field-error': multiplier.errors && multiplier.dirty && multiplier.errors.pattern }"
                type="text"
                maxlength="5"
                formControlName="multiplier"
              />
            </mat-form-field>
          </div>
          <div class="form-sign"><span>+</span></div>
          <div class="form-symbol">
            <mat-form-field>
              <input
                matInput
                class="form-symbol__input"
                [ngClass]="{ 'field-error': addition.errors && addition.dirty && addition.errors.pattern }"
                type="text"
                maxlength="5"
                formControlName="addition"
              />
            </mat-form-field>
          </div>
          <div class="form-sign">
            <h6>= Retail Price</h6>
          </div>
        </div>
      </div>
      <p class="error" *ngIf="multiplier.errors && multiplier.dirty && multiplier.errors.pattern">
        Multiplier must be between 0.00 - 99.99
      </p>
      <p class="error" *ngIf="addition.errors && addition.dirty && addition.errors.pattern">
        Addition must be between 0.00 - 99.99
      </p>
    </div>
    <div class="form-replace-digit">
      <div class="row collection-price-replace">
        <div class="col l5 m5 s12" validation>
          <mat-checkbox class="is-block mt-20 mb-20" (click)="toggleReplaceDisplay()"
            >Replace ending digits with:</mat-checkbox
          >
        </div>
        <div class="col l2 m2 s3 form-symbol" [hidden]="!isReplaceShown">
          <mat-form-field>
            <input matInput class="form-symbol-replace__input" formControlName="replace" />
          </mat-form-field>
         
        </div>
        <div class="col l5 m5 s9 collection-price-validation">
          <p [hidden]="!isReplaceShown">Valid input: $#.X#, $#.#X, $#.##</p>
        </div>
      </div>
    </div>
    <p style="margin-top: -25px" class="error" *ngIf="replace.errors && replace.dirty && replace.errors.pattern">
      Invalid input.
    </p>

    <div class="button-container btn-group">
      <button mat-button class="btn btn-secondary" (click)="closeDialog(false)">Cancel</button>
      <button
        mat-button
        class="btn btn-primary"
        type="submit"
        [disabled]="!formulaForm.valid"
        [ngClass]="{ disabled: !formulaForm.valid, success: formulaForm.valid }"
        (click)="closeDialog(true)"
      >
        Apply Formula
      </button>
    </div>
  </form>
</div>
